var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Alert triangle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18 13.1249V18.9583M18 24.7916H18.0146M15.5063 5.6291L3.15417 26.2499C2.89949 26.691 2.76474 27.191 2.76332 27.7003C2.76189 28.2096 2.89384 28.7103 3.14604 29.1528C3.39824 29.5952 3.76189 29.9639 4.20082 30.2222C4.63976 30.4805 5.13867 30.6193 5.64792 30.6249H30.3521C30.8613 30.6193 31.3602 30.4805 31.7992 30.2222C32.2381 29.9639 32.6018 29.5952 32.854 29.1528C33.1062 28.7103 33.2381 28.2096 33.2367 27.7003C33.2353 27.191 33.1005 26.691 32.8458 26.2499L20.4938 5.6291C20.2338 5.2005 19.8677 4.84615 19.4309 4.60022C18.9941 4.35429 18.5013 4.2251 18 4.2251C17.4987 4.2251 17.0059 4.35429 16.5691 4.60022C16.1323 4.84615 15.7662 5.2005 15.5063 5.6291Z",
    stroke: "#FFD049",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.af1d5a9749a31cc5269d89d02decaf85.svg";
export { ForwardRef as ReactComponent };